import { render } from "./AddDebt.vue?vue&type=template&id=70c5dda0"
import script from "./AddDebt.vue?vue&type=script&lang=js"
export * from "./AddDebt.vue?vue&type=script&lang=js"

import "./AddDebt.vue?vue&type=style&index=0&id=70c5dda0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__